import {webRequest, webNoTokenRequest} from '../api'

// 取得房源合約版本
export function getDefaultContract(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/getContract',
        method:'get',
        params: params
    })
}


// WEBPACK FOOTER //
// ./src/apis/company/contractMgt.js